<div class="layers-list">
  <!-- Terrain Background Selection -->
  <div class="terrain-selector">
    <button
      class="terrain-btn"
      [class.active]="!terrainMapVisible() && !terrainAerialVisible()"
      [class.loading]="terrainLoading()"
      (click)="selectTerrainBackground('none')"
      [title]="'layersPanel.terrainNone' | transloco"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <line x1="3" y1="3" x2="21" y2="21" />
      </svg>
    </button>
    <button
      class="terrain-btn"
      [class.active]="terrainMapVisible()"
      [class.loading]="terrainMapLoading()"
      (click)="selectTerrainBackground('map')"
      [title]="'layersPanel.terrainMap' | transloco"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
        <line x1="8" y1="2" x2="8" y2="18" />
        <line x1="16" y1="6" x2="16" y2="22" />
      </svg>
    </button>
    <button
      class="terrain-btn"
      [class.active]="terrainAerialVisible()"
      [class.loading]="terrainAerialLoading()"
      (click)="selectTerrainBackground('aerial')"
      [title]="'layersPanel.terrainAerial' | transloco"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M3 20h18L15 8l-4 6-3-3-5 9z" />
        <circle cx="18" cy="5" r="2" />
      </svg>
    </button>
  </div>

  <!-- Point Cloud Layer -->
  <label class="layer-item" [class.loading]="digitalTwinLoading()" (click)="togglePointCloud()">
    <span class="layer-icon point-cloud-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="6" cy="6" r="2" />
        <circle cx="12" cy="4" r="2" />
        <circle cx="18" cy="7" r="2" />
        <circle cx="4" cy="12" r="2" />
        <circle cx="10" cy="11" r="2" />
        <circle cx="16" cy="13" r="2" />
        <circle cx="8" cy="18" r="2" />
        <circle cx="14" cy="19" r="2" />
        <circle cx="20" cy="17" r="2" />
      </svg>
    </span>
    <span class="layer-name">
      {{ 'layersPanel.pointCloud' | transloco }}
      @if (digitalTwinLoading()) {
        <span class="loading-indicator"></span>
      }
    </span>
    <span class="layer-toggle" [class.active]="pointCloudVisible()"></span>
  </label>

  <!-- 3D Buildings Layer -->
  <label class="layer-item" [class.loading]="tilesLoading()" (click)="toggleTiles()">
    <span class="layer-icon tiles-icon">
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M12 3L2 8l10 5 10-5-10-5z" />
        <path d="M2 16l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    </span>
    <span class="layer-name">
      {{ 'layersPanel.buildings3d' | transloco }}
      @if (tilesLoading()) {
        <span class="loading-indicator"></span>
      }
    </span>
    <span class="layer-toggle" [class.active]="tilesVisible()"></span>
  </label>
</div>

@if (vectorTileLayerCatalog().length > 0) {
  <div class="layers-list">
    @for (layer of vectorTileLayerCatalog(); track layer.id) {
      <label
        class="layer-item"
        [class.disabled]="!isTerrainActive"
        (click)="toggleVectorTileLayer(layer.id)"
      >
        <span class="layer-icon feature-layer-icon">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
          </svg>
        </span>
        <span class="layer-name">{{ vectorTileLayerLabel(layer) }}</span>
        <span class="layer-toggle" [class.active]="isVectorTileLayerActive(layer.id)"></span>
      </label>
    }
  </div>
}

<div class="divider">
  <span>{{ 'layersPanel.background' | transloco }}</span>
</div>

<app-dropdown
  [value]="currentBackground"
  [options]="backgroundOptions"
  (valueChange)="onBackgroundChange($event)"
  width="100%"
></app-dropdown>

<div class="divider">
  <span>{{ 'layersPanel.pointcloudColorBy' | transloco }}</span>
</div>

<app-dropdown
  [value]="currentColorAttribute"
  [options]="colorOptions"
  (valueChange)="onColorAttributeChange($event)"
  width="100%"
></app-dropdown>

<!-- RGB Controls -->
@if (isRGBActive) {
  <ul class="pv-menu-list">
    <li>
      <span>{{ 'layersPanel.gamma' | transloco }}</span>
      :
      <span>{{ rgbGamma.toFixed(2) }}</span>
      <app-slider
        [min]="0"
        [max]="4"
        [step]="0.01"
        [value]="rgbGamma"
        (valueChange)="onRGBGammaChange($event)"
        width="100%"
      ></app-slider>
    </li>
    <li>
      <span>{{ 'layersPanel.brightness' | transloco }}</span>
      :
      <span>{{ rgbBrightness.toFixed(2) }}</span>
      <app-slider
        [min]="-1"
        [max]="1"
        [step]="0.01"
        [value]="rgbBrightness"
        (valueChange)="onRGBBrightnessChange($event)"
        width="100%"
      ></app-slider>
    </li>
    <li>
      <span>{{ 'layersPanel.contrast' | transloco }}</span>
      :
      <span>{{ rgbContrast.toFixed(2) }}</span>
      <app-slider
        [min]="-1"
        [max]="1"
        [step]="0.01"
        [value]="rgbContrast"
        (valueChange)="onRGBContrastChange($event)"
        width="100%"
      ></app-slider>
    </li>
  </ul>
}

<!-- Intensity Controls -->
@if (isIntensityActive) {
  <ul class="pv-menu-list">
    <li>
      <span>{{ 'layersPanel.gamma' | transloco }}</span>
      :
      <span>{{ intensityGamma.toFixed(2) }}</span>
      <app-slider
        [min]="0"
        [max]="4"
        [step]="0.01"
        [value]="intensityGamma"
        (valueChange)="onIntensityGammaChange($event)"
        width="100%"
      ></app-slider>
    </li>
    <li>
      <span>{{ 'layersPanel.brightness' | transloco }}</span>
      :
      <span>{{ intensityBrightness.toFixed(2) }}</span>
      <app-slider
        [min]="-1"
        [max]="1"
        [step]="0.01"
        [value]="intensityBrightness"
        (valueChange)="onIntensityBrightnessChange($event)"
        width="100%"
      ></app-slider>
    </li>
    <li>
      <span>{{ 'layersPanel.contrast' | transloco }}</span>
      :
      <span>{{ intensityContrast.toFixed(2) }}</span>
      <app-slider
        [min]="-1"
        [max]="1"
        [step]="0.01"
        [value]="intensityContrast"
        (valueChange)="onIntensityContrastChange($event)"
        width="100%"
      ></app-slider>
    </li>
  </ul>
}

<!-- Color Picker -->
@if (isColorPickerActive) {
  <div class="color-picker-wrapper">
    <span>{{ 'layersPanel.color' | transloco }}</span>
    <input
      type="color"
      [value]="solidColor"
      (change)="onSolidColorChange($any($event.target).value)"
      (input)="onSolidColorChange($any($event.target).value)"
      style="width: 100%; height: 40px; cursor: pointer; border: 1px solid #ccc; border-radius: 4px"
    />
  </div>
}

<!-- Classification Panel -->
@if (isClassificationActive) {
  <div class="classification-container">
    <app-classification-panel [items]="classificationItems" />
  </div>
}
